import { Typography } from '../../../designComponents';
import Timeline from '../../../designComponents/Timeline';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { humanReadableDate } from '../../../utils';
import { ViewProposalContainerStyled } from './style';
type Props = {
  startingDate: string;
  endDate: string;
};

const ProjectTimeline = (_props: Props) => {
  const events = [
    {
      date: humanReadableDate(_props.startingDate),
      title: 'Starting Date',
    },
    {
      date: humanReadableDate(_props.endDate),
      title: 'End Date',
    },
    //
  ];
  return (
    <ViewProposalContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        TIMELINE OF PROJECT{' '}
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Timeline events={events} />
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ViewProposalContainerStyled>
  );
};

export default ProjectTimeline;
